import { Component } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';

@Component({
    templateUrl: './account-workgroups.page.html'
})
export class AccountWorkgroupsPage {
    public WorkgroupsUrl: string = PKIUrls.WorkgroupsUrl;
    currentUserGuid!: string;
    constructor(private settingsService: SettingsService, private settingsBreadCrumbService: SettingsBreadCrumbService) {
        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetCrumbs(BreadCrumbOptions.Account, BreadCrumbOptions.Account_Workgroups);
        this.currentUserGuid = this.settingsService.currentUserId;
    }
}
